import type { Translations } from './types';

const fr: Translations = {
    next: 'Suivant',
    storyReadPrompt: "Lis d'abord l'histoire, s'il te plaît.",
    backToStory: '← Retour à l\'histoire',
    nextArrow: 'Suivant →',
    finishAssessment: 'Terminer l\'évaluation →',
    common_step: 'Étape',
    questionsStory1: 'Questions — Histoire 1',
    questionsStory2: 'Questions — Histoire 2',
    lastSetOfQuestions: 'Dernières questions — presque fini ! 🎉',
    typeAnswerHere: 'Écris ta réponse ici...',
    backCountSingular: '📖 Tu es revenu {n} fois sur cette page pour relire l\'histoire.',
    backCountPlural: '📖 Tu es revenu {n} fois sur cette page pour relire l\'histoire.',

    assessmentComplete: "Évaluation terminée ! 🎉",
    assessmentSubtitle: "Tu as fait un pas important vers la compréhension des troubles de l'apprentissage",
    returnToHome: "Retour à l'accueil",
    assessmentSuccessfullyCompleted: "Évaluation réussie",
    amazingJob: "Excellent travail !",
    youCrushedIt: "Tu as réussi ! Voici ce que tu as accompli :",
    whatsNext: "Et ensuite ?",
    getReadyForResults: "Prépare-toi à recevoir tes résultats personnalisés",
    youDidIt: "Tu l'as fait !",
    youDidItDesc:
      "Ton engagement à comprendre les troubles de l'apprentissage est vraiment inspirant. Alors que d'autres auraient pu abandonner, tu es allé jusqu'au bout !",

    heroLine1: "DÉPISTAGE",
    heroLine2: "DYSLEXIE",
    heroTagline: 'en une seule séance',
    heroSubtitle:
      'Une évaluation multimodale dans le navigateur qui vous remet un rapport écrit dès la fin du test — sans rendez-vous en clinique, sans liste d\'attente, sans matériel spécial.',
    heroBetaLabel: 'BÊTA',
    startAssessment: 'Commencer',
    trustedBy: "Approuvé par des éducateurs et chercheurs du monde entier",

    pfp_privacyBadge: 'Confidentialité & Conformité',
    pfp_privacyHeading: 'Nous prenons la protection des données au sérieux avec une pleine conformité RGPD et MDR',
    pfp_formBadge: 'Commencer votre évaluation',
    pfp_ctaHeading: 'DÉPISTAGE DYSLEXIE',
    pfp_ctaDesc: "Rejoignez des milliers de personnes qui ont découvert des informations uniques sur leur style de lecture grâce à notre évaluation basée sur l'IA.",
    pfp_ctaFooter: 'Pas de limite de temps • À votre propre rythme • 100% confidentiel',
    pfp_whyTitle: 'Pourquoi DysTest ?',
    pfp_whySubtitle: "Découvrez ce qui fait de notre évaluation basée sur l'IA la solution la plus précise et fiable",
    pfp_whyDesc: "DysTest combine plus de 20 ans d'expertise professionnelle dans la recherche sur la dyslexie avec une vie d'expérience. En reconstituant la façon dont les lecteurs dyslexiques et neurotypiques traitent le texte, notre IA apprend à distinguer des modèles de lecture subtils que les tests traditionnels manquent.",
    pfp_feature1Title: 'Suivi oculaire, dynamique clavier & insights multilingues',
    pfp_feature1Desc: "L'IA avancée analyse les mouvements oculaires, les expressions faciales et les frappes clavier pour révéler des modèles d'apprentissage uniques à chaque lecteur — dans n'importe quelle langue. DysTest s'adapte intelligemment aux utilisateurs multilingues pour une compréhension précise et personnalisée.",
    pfp_feature2Title: 'Résultats Instantanés et Exploitables',
    pfp_feature2Desc: "Obtenez des informations claires et soutenues par la science en quelques minutes. Nos rapports traduisent des données complexes en recommandations accessibles qui donnent du pouvoir aux parents, aux éducateurs et aux apprenants.",
    pfp_feature3Title: 'Confidentialité & Conformité d\'Abord',
    pfp_feature3Desc: "Vos données sont chiffrées, anonymisées et traitées selon les normes éthiques et réglementaires les plus élevées — entièrement conformes au RGPD et au MDR. Rien n'est partagé au-delà de l'amélioration de votre expérience DysTest.",
    pfp_feature4Title: 'Design Accessible et Centré sur l\'Humain',
    pfp_feature4Desc: "DysTest vous permet de dépister à votre propre rythme — calme, intuitif et sans pression. Conçu pour l'inclusivité, l'accessibilité et la compréhension significative, il redéfinit la façon dont les différences d'apprentissage sont découvertes et soutenues.",
    pfp_finalCtaDesc: "Commencez votre dépistage de dyslexie personnalisé basé sur l'IA aujourd'hui — conçu pour comprendre comment vous lisez, pas seulement ce que vous lisez.",

    hiw_badge: 'Processus simple en 8 étapes',
    hiw_heading: "Comment fonctionne l'évaluation",
    hiw_subtext: "De l'inscription à un rapport d'évaluation de la dyslexie détaillé — entièrement dans le navigateur, aucun téléchargement requis.",
    hiw_step1Title: "S'inscrire",
    hiw_step1Desc: "Entrez votre nom, âge et langue préférée. Aucun compte requis — prend moins de 2 minutes.",
    hiw_step2Title: 'Calibration oculaire',
    hiw_step2Desc: "Suivez 16 points animés sur l'écran. Le tracker iris IA apprend votre signature de regard unique.",
    hiw_step3Title: 'Mots & Images',
    hiw_step3Desc: 'Associez des mots à leurs images pendant que nous mesurons la vitesse de reconnaissance et le traitement visuo-phonologique.',
    hiw_step4Title: 'Test de vitesse RAN',
    hiw_step4Desc: "Nommez rapidement une séquence de couleurs ou d'objets à voix haute. Mesure la fluidité de récupération.",
    hiw_step5Title: 'Histoires & Questions',
    hiw_step5Desc: "Lisez deux histoires adaptées à l'âge et répondez aux questions de compréhension. Les mouvements oculaires et les clignements sont enregistrés.",
    hiw_step6Title: 'Écriture de mots',
    hiw_step6Desc: "Tapez des mots de mémoire. Le chronométrage des frappes et les patterns d'erreurs révèlent l'orthographe et le traitement moteur.",
    hiw_step7Title: "Retour d'information",
    hiw_step7Desc: 'Partagez votre expérience et vos préoccupations. Ce contexte aide à calibrer l\'interprétation clinique.',
    hiw_step8Title: 'Obtenir les résultats',
    hiw_step8Desc: "Recevez un rapport détaillé avec des indicateurs de risque de dyslexie, des cartes thermiques du regard et des métriques de lecture.",

    pf_whoTaking: 'Qui passe le test ?',
    pf_myself: 'Moi-même',
    pf_myselfAge: 'Âge 13+',
    pf_child: 'Enfant',
    pf_childAgeRange: 'Âge 5-12',
    pf_verifyEmailTitle: 'Vérifiez votre e-mail',
    pf_parentalConsentStepTitle: 'Consentement parental',
    pf_verifyEmailDesc: 'Entrez le code envoyé à votre e-mail pour finaliser l\'inscription',
    pf_consentDesc: 'Veuillez examiner et donner votre consentement pour le traitement des données',
    pf_yourName: 'Nom du participant *',
    pf_yourNamePlaceholder: 'Entrez votre nom complet',
    pf_emailAddress: 'Adresse e-mail *',
    pf_assessmentLanguage: 'Langue de l’évaluation',
    pf_emailPlaceholder: 'Entrez votre e-mail',
    pf_invalidEmail: 'Veuillez entrer une adresse e-mail valide',
    pf_yourAge: 'Votre âge *',
    pf_selectAge: 'Sélectionnez votre âge',
    pf_yearsUnit: 'ans',
    pf_dyslexiaTested: 'Avez-vous été testé pour la dyslexie ? *',
    pf_iAmDyslexic: 'Oui, diagnostiqué officiellement',
    pf_iAmNotDyslexic: "Testé et non dyslexique",
    pf_notKnown: 'Pas connu',
    pf_parentName: 'Nom du parent *',
    pf_parentNamePlaceholder: 'Entrez le nom du parent',
    pf_childName: "Nom de l'enfant *",
    pf_childNamePlaceholder: "Entrez le nom de l'enfant",
    pf_childAgeLabel: "Âge de l'enfant *",
    pf_selectChildAge: "Sélectionnez l'âge de l'enfant",
    pf_childDyslexiaTested: 'Votre enfant a-t-il été testé pour la dyslexie ? *',
    pf_yesHasDyslexia: 'Oui, diagnostiqué officiellement',
    pf_yesNoDyslexia: "Testé et non dyslexique",
    pf_noNotTested: 'Non, jamais testé',
    pf_nativeLangQuestion: 'Quelle langue parlez-vous à la maison ?',
    pf_browserLangDetected: 'Langue du navigateur détectée :',
    pf_availableInSystem: '✓ Disponible dans notre système',
    pf_yesNative: 'Oui, c\'est ma langue maternelle',
    pf_othersNative: "Autres, j'utilise d'autres langues plus souvent",
    pf_specifyNative: 'Précisez votre langue maternelle *',
    pf_selectNativePlaceholder: 'Sélectionnez votre langue maternelle',
    pf_selectNativeError: 'Veuillez sélectionner votre langue maternelle',
    pf_nativeLangNote: "Cela nous aide à fournir des résultats d'évaluation plus précis en fonction de votre contexte linguistique. Votre langue de navigateur ({lang}) a été détectée automatiquement — nous n'utilisons jamais votre adresse IP pour la détection de langue.",
    pf_forYourChild: 'Pour votre enfant',
    pf_childExplanation: "L'ordinateur regarde comment tu lis — ton visage, tes yeux et ta frappe — pour comprendre ton style de lecture. Rien de mal n'arrive à tes données. Ton parent a dit que c'était bon, et tu peux arrêter quand tu veux.",
    pf_parentalConsentLabel: 'Consentement parental *',
    pf_parentalConsentText: "Je consens au traitement des données faciales, de mouvement des yeux et d'interaction clavier de mon enfant (ou des miennes) pour le dépistage de la dyslexie et l'évaluation de l'apprentissage, conformément au RGPD et à la MDR.",
    pf_dataConsentLabel: 'Consentement au traitement des données et politique de confidentialité *',
    pf_dataConsentText: "J'accepte le traitement de mes données personnelles à des fins de dépistage.\nJ'ai lu et j'accepte la politique de confidentialité et les conditions d'utilisation.",
    pf_consentPre: "J'accepte la",
    pf_consentPrivacyLink: 'Politique de confidentialité',
    pf_consentBetween: 'et les',
    pf_consentTermsLink: "Conditions d'utilisation",
    pf_consentPost: ', y compris le traitement des données à des fins de dépistage.',
    pf_emailFailedTitle: "Échec de l'envoi de l'e-mail",
    pf_checkYourEmail: 'Vérifiez votre e-mail',
    pf_emailSentDesc: 'Nous avons envoyé un code de vérification à 6 chiffres à {email}. Veuillez vérifier votre boîte de réception et entrer le code ci-dessous.',
    pf_emailFailedDesc: "Échec de l'envoi à {email}.",
    pf_tryAgain: 'Réessayer',
    pf_sendingEmail: 'Envoi en cours...',
    pf_verificationCodeLabel: 'Code de vérification *',
    pf_enterCodePlaceholder: 'ENTREZ LE CODE À 6 CHIFFRES',
    pf_codeExpiry: "Entrez le code à 6 chiffres de votre e-mail. Le code expire dans 15 minutes.",
    pf_resendCode: "Vous n'avez pas reçu le code ? Cliquez pour renvoyer",
    pf_sendingNewCode: 'Envoi du nouveau code...',
    pf_continue: 'Continuer',
    pf_continueToConsent: 'Continuer vers le consentement',
    pf_verifyEmailBtn: "Vérifier l'e-mail",
    pf_verifying: 'Vérification...',
    pf_processing: 'Traitement...',
    pf_importantNotice: 'Avis important',
    pf_disclaimer: "DysTest est un outil de dépistage numérique conçu pour soutenir la détection précoce et les informations sur l'apprentissage. Il ne fournit pas de diagnostic médical. Pour un diagnostic officiel ou un avis clinique, veuillez consulter des professionnels de santé qualifiés.",
            cg_readingAssessment: 'Évaluation de lecture',
    cg_whatsNext: 'Voici ce qui vient ensuite',
    cg_twoSections: 'Deux courtes sections — lis une histoire, puis réponds à quelques questions',
    cg_readStory: "Lis l'histoire",
    cg_readStoryDesc: 'Prends ton temps — lis à ton propre rythme',
    cg_answerQuestions: 'Réponds à quelques questions',
    cg_answerQuestionsDesc: 'Écris tes réponses avec tes propres mots — pas de bonne ou mauvaise réponse',
    cg_exampleQuestion: "Que s'est-il passé au début de l'histoire ?",
    cg_exampleAnswer: 'Le garçon est allé au parc…',
    cg_startReading: 'Commencer à lire',
    cg_warmupGame: "Jeu d'échauffement",
    cg_matchHeading: "Associe le mot à l'image",
    cg_matchSubtitle: "Clique sur une carte mot, puis sur l'image correspondante pour compléter la paire",
    cg_startMatching: 'Commencer!',
    cg_demoWord: 'chat',
    cg_allMatched: 'Toutes les paires trouvées !',
    cg_heatmapContinuing: 'Votre carte de chaleur du regard est affichée ci-dessous — continuation prochaine…',
    cg_lookAtTarget: '👁️ Regardez la cible !',
    cg_lookAtDot: 'Regardez le point rouge',
    cg_sRemaining: 's restantes',
    cg_skipFixation: 'Passer la fixation',
    cg_correct: '✓ Correct !',
    cg_tryAgain: '✗ Réessayez',
    cg_liveMetrics: 'Métriques en direct',
    cg_blinks: 'Clignements',
    cg_matched: 'Trouvées',
    cg_errors: 'Erreurs',
    fpc_instruction: 'Regardez chaque point',
    fpc_dotsTotal: 'points au total — regardez directement chaque point et maintenez votre regard. La capture est automatique.',
    fpc_cancelCalibration: 'Annuler la calibration',
    fpc_clickMe: 'Cliquez ici !',
    fpc_eyeTrackingStarting: 'Suivi oculaire en cours — vous pouvez déjà cliquer !',
    fpc_calibrationComplete: 'Calibration terminée !',
    fpc_trainingSamples: '{n} échantillons d\'entraînement enregistrés',
    fpc_allPointsDone: 'Tous les points terminés !',
    fpc_pointOf: 'Point {current} sur {total}',
    fpc_training: 'Entraînement',
    fpc_inactive: 'Calibration inactive',
    fpc_savingCalibration: 'Enregistrement de la calibration…',
    fpc_moveEyes: 'Déplacez vos yeux vers le point…',
    fpc_noFace: '⚠️ Aucun visage détecté — centrez votre visage dans la caméra',
    fpc_missingIrisTitle: "⚠️ Données de l'iris manquantes sur trop de points",
    fpc_missingIrisBody: "Plusieurs points de calibration ont été ignorés car les repères de l'iris n'ont pas été détectés.",
    fpc_lowAccuracyTitle: 'Précision inférieure aux attentes',
    fpc_lowAccuracyBody: "L'erreur de calibration est plus élevée qu'idéal. Cela peut réduire la précision du suivi du regard.",
    fpc_redoCalibration: 'Refaire la calibration',
    fpc_continueAnyway: 'Continuer quand même',
    fpc_lookAtDot: 'Regardez directement le point',
    fpc_dotReady: '✓ Point capturé — passage suivant…',
    fpc_keepLooking: 'Continuez à regarder le point — la capture est automatique',
    fpc_captured: "✓ Capturé ! Passage au suivant…",
    fpc_checkingAccuracy: 'Vérification de la précision',
    fpc_valGotIt: "C'est bon ! Passage au suivant…",
    fpc_valHoldStill: 'Restez immobile — collecte en cours…',
    fpc_valLookDot: 'Regardez le point — il devient orange quand il est prêt',
    fpc_valCheck: 'VÉRIF',

    acp_welcome: 'Bienvenue, {name} !',
    acp_setupSubtitle: 'Configurons votre évaluation',
    acp_setupVerification: 'Vérification de configuration',
    acp_setupStepsDesc: "Complétez toutes les étapes pour déverrouiller l'évaluation",
    acp_step1Title: 'Caméra active',
    acp_step1Desc: 'La caméra démarre automatiquement — aucune action requise',
    acp_step2Title: 'Vérification caméra',
    acp_step2Desc: 'Vérifier la qualité et la stabilité de la caméra',
    acp_step3Title: 'Test de frappe',
    acp_step3Desc: 'Vérifier la fonctionnalité du clavier',
    acp_step4Title: 'Calibration oculaire',
    acp_step4Desc: 'Calibrer le système de suivi oculaire',
    acp_eyeTrackingActive: '✓ Suivi oculaire actif',
    acp_eyeTrackingError: '⚠ Erreur de suivi oculaire :',
    acp_startingEyeTracking: '⏳ Démarrage du suivi oculaire...',
    acp_cameraReady: '👁 Caméra prête',
    acp_waitingForCamera: '📷 Démarrage automatique de la caméra...',
    acp_stepDone: 'Terminé',
    acp_stepInProgress: 'En cours',
    acp_checkingCameraStability: 'Vérification de la stabilité de la caméra...',
    acp_cameraVerified: 'Caméra vérifiée ✓',
    acp_autoVerifyingCamera: 'Vérification automatique de la caméra...',
    acp_waitingFaceDetection: 'En attente de la détection du visage...',
    acp_eyeTrackingStarting: 'Démarrage du suivi oculaire...',
    acp_calibrationInProgress: 'Calibration en cours...',
    acp_eyeTrackingReady: 'Suivi oculaire prêt ✓',
    acp_startingCalibration: 'Démarrage de la calibration...',
    acp_distanceHint: 'Garde ton visage au centre et immobile, à 60 cm de l\'écran au maximum',
    acp_distanceLabel: 'max. 60 cm',
    acp_fpsTitle: 'Ta caméra est un peu lente',
    acp_fpsBody: 'Elle fournit {fps} images par seconde ; il en faut au moins 10 pour mesurer le regard. Ceci aide en général en quelques secondes :',
    acp_fpsVeryLow: 'À cette vitesse, certaines mesures des mouvements des yeux risquent de ne pas être utilisables ; les autres tâches comptent quand même.',
    acp_fpsTipLight: 'Allume plus de lumière ou tourne-toi vers une fenêtre',
    acp_fpsTipCharger: 'Branche le chargeur (l\'économie de batterie ralentit l\'ordinateur)',
    acp_fpsTipApps: 'Ferme les appels vidéo et les autres programmes lourds',
    acp_fpsCheckAgain: 'Vérifier à nouveau',
    acp_fpsChecking: 'Vérification…',
    acp_fpsContinue: 'Continuer quand même',
    acp_preparingEyeTracking: 'Préparation du suivi oculaire...',
    acp_cameraPreview: 'Aperçu caméra',
    acp_noFaceDetected: 'Aucun visage détecté',
    acp_live: 'EN DIRECT',
    acp_cameraVerifiedTitle: 'Caméra vérifiée ✓',
    acp_cameraReadyTitle: 'Caméra prête',
    acp_qualityCheckPassed: 'Contrôle qualité réussi',
    acp_optimizedForAssessment: "Optimisé pour l'évaluation",
    acp_verifiedBadge: 'Vérifié',
    acp_readyBadge: 'Prêt',
    acp_assessmentMetrics: "Métriques d'évaluation",
    acp_faceDistance: 'Distance du visage',
    acp_goodDistance: "Bonne distance pour l'évaluation",
    acp_searching: 'Recherche...',
    acp_lightLevel: 'Niveau de lumière',
    acp_fps: 'IPS',
    acp_fpsExcellent: 'Excellent taux de trame',
    acp_fpsGood: 'Bon taux de trame',
    acp_fpsModerate: 'Taux de trame modéré',
    acp_fpsLow: 'Faible taux de trame',
    acp_fpsInitializing: 'Initialisation...',
    acp_faceDetection: 'Détection du visage',
    acp_faceDetected: '✓ Détecté',
    acp_faceDetectedSub: 'Visage détecté avec succès',
    acp_cameraQualityPassed: "Contrôle qualité caméra réussi. Prêt pour l'étape suivante.",
    acp_visionWarnings: 'Avertissements visuels',
    acp_trackingMetrics: 'Métriques de suivi',
    acp_headPitch: 'Inclinaison tête :',
    acp_headYaw: 'Rotation tête :',
    acp_headRoll: 'Roulis tête :',
    acp_gazePoint: 'Point de regard :',
    acp_emotion: 'Émotion :',
    acp_confidence: 'Confiance :',
    acp_trackingId: 'ID de suivi :',
    acp_faceId: 'ID visage :',
    acp_browser: 'Navigateur :',
    acp_os: 'OS :',
    acp_camera: 'Caméra :',
    acp_resolution: 'Résolution :',
    acp_initializingTracking: 'Initialisation des métriques de suivi...',
    acp_dataQuality: 'Qualité des données',
    acp_dataQualityExcellent: 'EXCELLENT',
    acp_dataQualityGood: 'BON',
    acp_dataQualityFair: 'ACCEPTABLE',
    acp_dataQualityDetecting: 'DÉTECTION...',
    acp_dataQualityExcellentDesc: "Optimal pour l'évaluation",
    acp_dataQualityGoodDesc: "Bon pour l'évaluation",
    acp_dataQualityFairDesc: 'Qualité acceptable',
    acp_dataQualityDetectingDesc: 'Analyse des conditions',
    acp_faceMeshPoints: 'Points du maillage facial',
    acp_completeFaceMesh: 'Maillage facial complet',
    acp_detecting: 'Détection...',
    acp_typingTest: 'Test de frappe',
    acp_typeQwerty: 'Tapez {target} pour vérifier le clavier',
    acp_verifyKeyboard: 'Vérifier la fonctionnalité du clavier',
    acp_activeStatus: 'Actif',
    acp_lockedStatus: 'Verrouillé',
    acp_typeHere: 'Tapez ici...',
    acp_typingCompleted: '✓ Terminé ! Passage à l\'étape suivante...',
    acp_keepTyping: 'Continuez à taper :',
    acp_remaining: 'restant',
    acp_startTyping: 'Commencez à taper les lettres ci-dessus',
    acp_completeCameraVerification: 'Complétez la vérification caméra pour déverrouiller',
    acp_lightingPerfect: "Éclairage parfait pour l'évaluation",
    acp_lightingSlightlyBright: 'Légèrement lumineux — réduisez si possible',
    acp_lightingTooBright: 'Trop lumineux — réduisez l\'éclairage/luminosité',
    acp_lightingSlightlyDim: 'Légèrement sombre — augmentez si possible',
    acp_lightingTooDim: "Trop sombre — augmentez l'éclairage",
    acp_positionFace: '👤 Positionnez votre visage dans la vue caméra',
    acp_faceDetectedStarting: '✅ Visage détecté — démarrage de la vérification...',
    acp_adjustDistance: 'Ajustez votre distance par rapport à la caméra',
    acp_moveFarther: 'Éloignez-vous de la caméra',
    acp_distanceInRange: 'La distance semble correcte',
    pdg_moveCloser: 'Rapprochez-vous de la caméra',
    pdg_moveFarther: 'Éloignez-vous de la caméra',
    pdg_dismiss: 'Ignorer',
    acp_noData: 'Aucune donnée',
    acp_setupProgress: 'Progression de la configuration',
    acp_stepsComplete: '{n} sur 4 étapes terminées',
    acp_environment: 'Environnement',
    acp_checkingEllipsis: 'Vérification…',
    acp_waitingEllipsis: 'En attente…',
    acp_analysingConditions: 'Analyse des conditions de la caméra…',
    acp_positionFaceCamera: 'Positionnez votre visage devant la caméra',
    acp_faceAligned: 'Visage aligné',
    shared_stepOf: 'Étape {step} sur {total}',
    shared_start: 'démarrer',
    cal_introHeading: 'CALIBRATION',
    cal_introSubtitle: 'Suivez les points et gardez la tête immobile',
    story_introHeading: 'LECTURE ET QUESTIONS',
    fpc_lookHere: '👆 Cliquez sur le point pour continuer',
            pfp_chip_gdpr: 'Conforme RGPD',
    pfp_chip_mdr: 'Aligné MDR',
    pfp_chip_noData: 'Pas de partage de données',
    pfp_chip_languages: '8 Langues',
    kbv_header: 'Capture de la dynamique clavier',
    kbv_interKey: 'Intervalle entre touches',
    kbv_typingSpeed: 'Vitesse de frappe',
        pfp_aiBadge: 'Outil de dépistage de la dyslexie par suivi oculaire',
    pfp_whyBadge: 'Pourquoi DysTest',
    mat_missionBadge: 'Notre mission & technologie',
    mat_eyeBadge: 'Suivi oculaire',
    mat_kbdBadge: 'Analyse des frappes',
    mat_ferBadge: 'Expression faciale',
    pfp_noBrowserFooter: 'Sans compte · Entièrement dans le navigateur · Résultats en <15 minutes',
    eye_viz_landmarks: '478 Points clés',
    eye_viz_irisFaceMesh: 'Iris + Maillage facial',
    eye_viz_fps: '30 FPS en temps réel',
    eye_viz_validation: 'Validation 9 + 4 points',
    eye_viz_calibration: 'Calibrage clinique 13 points',
    ran_anim_rapidNaming: 'Dénomination rapide',
    ran_anim_predictor: 'N°1 indicateur de dyslexie',
    ran_anim_ageNormed: 'Notation normée par âge',
    ran_anim_zscore: 'score z + percentile',
    acp_hideDetails: 'Masquer les détails ▲',
    acp_showDetails: 'Afficher les détails ▼',
    acp_moveCloser: 'rapprochez-vous',
    acp_headLabel: 'Tête',
    acp_setupTipsTitle: 'Conseils de configuration rapide',
    acp_tip1: 'Asseyez-vous à ~50 cm de votre écran',
    acp_tip2: 'Assurez un éclairage uniforme et lumineux sur votre visage',
    acp_tip3: 'Gardez la tête droite et regardez directement la caméra',
    acp_tip4: 'Utilisez un endroit calme pour une évaluation sans distraction',
    acp_progressLabel: 'Progression',

    priv_gdprTitle: 'Conforme au RGPD',
    priv_gdpr1: 'Consentement parental vérifiable pour les moins de 13 ans',
    priv_gdpr2: 'Minimisation des données et limitation des finalités',
    priv_gdpr3: "Droit d'accès, de rectification et de suppression des données",
    priv_gdpr4: 'Traitement transparent des données',
    priv_mdrTitle: 'Aligné sur le RDM',
    priv_mdr1: 'Protection renforcée pour les sujets vulnérables',
    priv_mdr2: 'Sécurité clinique et performance',
    priv_mdr3: 'Distinction claire entre dépistage et diagnostic',
    priv_mdr4: 'Traitement éthique des données de santé',
    priv_retentionTitle: 'Politique de conservation des données',
    priv_12months: '12 mois',
    priv_12monthsDesc: 'Coordonnées de suivi oculaire & frappes clavier',
    priv_24months: '24 mois',
    priv_24monthsDesc: "Métadonnées d'analyse",
    priv_parentsControl: 'Contrôle parental',
    priv_deleteAnytime: 'Supprimer à tout moment',

    mat_headline1: 'EMPATHIE HUMAINE.',
    mat_headline2: 'PRÉCISION ARTIFICIELLE',
    mat_subheadline: 'Allier expérience vécue et IA de pointe pour rendre le dépistage de la dyslexie',
    mat_subheadlineHighlight: 'accessible à tous',
    mat_whatTitle: 'CE QUE NOUS FAISONS',
    mat_what1: "Nous combinons une expertise approfondie des schémas de lecture dyslexiques avec une technologie d'IA avancée. Après des années de recherche, nous avons transmis ces connaissances à une IA adaptative.",
    mat_what2: 'Notre IA mène des tests intelligents et multicouches — chaque réponse comparée à des milliers de schémas de lecture réels. Elle apprend en temps réel et pose les bonnes questions de suivi.',
    mat_what3: "Tout pour donner aux familles la clarté dont elles ont besoin pour passer à l'étape suivante avec confiance.",
    mat_whyTitle: 'POURQUOI NOUS FAISONS CELA',
    mat_why1: 'Imaginez votre enfant confronté aux mêmes difficultés de lecture que vous autrefois — mais maintenant, vous savez que cela a un nom : la dyslexie. Vous voulez des réponses, mais le premier test coûte entre 750 et 1 800 € — hors de portée pour de nombreuses familles.',
    mat_why2: 'Cette réalité nous brise le cœur. Chaque enfant mérite de comprendre comment il apprend. Chaque parent mérite des réponses.',
    mat_why3: "C'est pourquoi nous sommes là — parce que comprendre son propre esprit ne devrait jamais être un privilège. C'est un droit humain.",
    mat_bgTitle: 'NOTRE PARCOURS',
    mat_bg1: "Nous avons nous-mêmes vécu avec la dyslexie et avons passé plus de 20 ans à nous spécialiser dans la lecture accessible. En combinant cette expérience avec l'IA, nous avons créé un outil de dépistage simple, abordable et porteur de changement.",
    mat_bg2: "Notre IA ne mesure pas seulement la vitesse de lecture ou ne compte pas les erreurs — elle comprend le comment derrière chaque mouvement oculaire, pause et correction. Elle examine les processus cognitifs qui rendent la lecture si difficile.",
    mat_techTitle: 'NOTRE TECHNOLOGIE',
    mat_tech1: "En amplifiant ces différences subtiles, notre système apprend à distinguer la dyslexie des autres difficultés de lecture avec une précision extraordinaire. Nous utilisons le deep clustering — une forme avancée d'apprentissage non supervisé.",
    mat_tech2: 'Cette approche multicouche et croisée apporte une plus grande certitude que toute méthode précédente — allant plus loin que jamais.',
    mat_eyeTitle: 'Suivi oculaire',
    mat_eyeText: 'Nous mesurons la stabilité du regard, la durée de fixation et les mouvements saccadiques pour révéler comment la mise au point visuelle évolue pendant la lecture.',
    mat_kbdTitle: 'Dynamique du clavier',
    mat_kbdText: 'Le rythme des frappes, les hésitations et la vitesse de correction révèlent des défis de séquençage et phonologiques propres aux profils dyslexiques.',
    mat_ferTitle: 'Reconnaissance des émotions faciales (FER)',
    mat_ferText: 'Les expressions subtiles révèlent frustration, engagement ou soulagement — aidant notre IA à percevoir la dimension émotionnelle derrière l\'effort de lecture.',

    footer_about: 'À propos',
    footer_blog: 'Publications',
    footer_contact: 'Contact',
    footer_faq: 'FAQ',
    footer_privacy: 'Confidentialité',
    footer_terms: "Conditions d'utilisation",
    footer_tagline: "Dépistage de la dyslexie par IA avec suivi d'iris en temps réel, dynamique du clavier et analyse des expressions faciales — disponible en 8 langues, entièrement dans le navigateur.",
    footer_productHeading: 'Produit',
    footer_legalHeading: 'Légal',
    footer_mission: 'Conçu pour rendre le dépistage de la dyslexie accessible à tous, dans toutes les langues.',
    footer_copyright: 'Tous droits réservés',
    footer_madeWith: 'Fait avec intention pour la sensibilisation à la dyslexie',
    footer_allSystems: 'Tous les systèmes opérationnels',

    fp_assessmentBadge: 'Dernière étape',
    fp_feedbackTitle: 'Partagez une dernière note',
    fp_feedbackDesc: 'Un retour facultatif nous aide à améliorer l’expérience d’évaluation.',
    fp_shareThoughts: 'Partagez vos impressions',
    fp_optional: 'Optionnel',
    fp_words: 'Mots',
    fp_corrections: 'Corrections',
    fp_speed: 'Vitesse',
    fp_feedbackPlaceholder: 'Quelque chose était difficile, peu clair ou à améliorer ?',
    fp_observationNotesTitle: 'Notes d’observation (facultatif)',
    fp_observationNotesDesc: 'Pour le parent ou la personne supervisant le test : tout ce que vous avez remarqué et que l’écran ne peut pas voir — distraction, fatigue, pleurs, bruit, ou toute autre chose à noter avec les résultats.',
    fp_observationNotesPlaceholder: 'ex. « Semblait fatigué pendant le test d’écriture de mots » ou « Distrait par un frère ou une sœur pendant l’Histoire 1 »',
    fp_generatingReport: 'Génération de votre rapport…',
    fp_submitBtn: 'Terminer et voir le rapport',
    fp_skipHint: 'Le retour est facultatif. Continuez quand vous êtes prêt.',
    fp_youNailedIt: 'Évaluation terminée',
    fp_reportGenerated: 'Votre rapport est prêt dans votre tableau de bord.',
    fp_copySentTo: 'Détails d’accès envoyés à',
    fp_welcomeBack: 'Rapport enregistré',
    fp_newReportAdded: 'Ajouté aux résultats de votre tableau de bord.',
    fp_reportReady: 'Votre rapport est prêt',
    fp_reportSubtitle: 'Analyse complète, lecture du mouvement oculaire & indicateurs de dyslexie',
    fp_openingReport: 'Ouverture de votre rapport…',
    fp_viewMyReport: 'Voir mon rapport',
    fp_signInLater: 'ou connectez-vous plus tard sur',
    fp_saveForAccess: 'Enregistrer pour un accès futur',
    fp_emailLabel: 'Email',
    fp_passwordLabel: 'Mot de passe',
    fp_copied: 'Copié',
    fp_copy: 'Copier',
    fp_pwUpdated: 'Mot de passe mis à jour avec succès',
    fp_setCustomPw: 'Définir un mot de passe personnalisé',
    fp_newPwPlaceholder: 'Nouveau mot de passe (min 4 caractères)',
    fp_save: 'Enregistrer',
    fp_cancel: 'Annuler',
    fp_signInLink: 'Ouvrir le tableau de bord →',
    fp2_saving: 'Enregistrement de vos résultats…',
    fp2_savingSub: 'Cela prend quelques secondes. Gardez cette page ouverte.',
    fp2_allDone: 'Terminé',
    fp2_reportReadySent: 'Le rapport est prêt. Nous avons envoyé les identifiants à',
    fp2_reportReadyReturning: 'Le rapport est prêt et a été ajouté à votre tableau de bord.',
    fp2_passwordLine: 'Votre mot de passe (aussi dans l\'e-mail) :',
    fp2_openReport: 'Ouvrir le rapport',
    fp2_saveFailed: 'Vos résultats n\'ont pas encore pu être enregistrés.',
    fp2_saveFailedSub: 'Vérifiez la connexion internet et réessayez. Gardez cette page ouverte.',
    fp2_tryAgain: 'Réessayer',
    fp2_sessionTitle: 'Y a-t-il quelque chose à savoir sur le test ?',
    fp2_sessionOptional: 'Facultatif · ne change pas le résultat',
    fp2_cTired: 'Fatigué ou distrait',
    fp2_cCameraMic: 'Problème de caméra ou de micro',
    fp2_cNoisy: 'Bruit ou interruptions',
    fp2_cLanguage: 'Pas la langue maternelle',
    fp2_cHelped: 'Quelqu\'un a aidé à répondre',
    fp2_cFroze: 'La page s\'est figée ou a dû être rechargée',
    fp2_saveNotes: 'Enregistrer les notes',
    fp2_notesSaved: 'Notes enregistrées',
    fp2_notesFailed: 'Les notes n\'ont pas pu être enregistrées. Veuillez réessayer.',
    fp_parentNote: '👨‍👩‍👧 Un message pour le parent',
    fp_parentNoteDesc: "L'évaluation est terminée. Partagez vos observations sur la façon dont votre enfant a abordé les tâches aujourd'hui (facultatif).",
    fp_screeningResult: 'Résultat du dépistage',
    fp_riskTypical: 'Typique — aucun indicateur significatif',
    fp_riskBorderline: 'Limite — quelques indicateurs présents',
    fp_riskHighRisk: 'Risque élevé — plusieurs indicateurs détectés',
    fp_riskVeryHighRisk: 'Risque très élevé — indicateurs forts dans plusieurs domaines',
    fp_confidence: 'Confiance',
    fp_keyFindings: 'Conclusions clés',
    fp_disclaimer: "Ceci est uniquement un outil de dépistage — pas un diagnostic clinique. Veuillez consulter un psychologue scolaire agréé pour une évaluation complète.",
    fp_notAssessed: 'Non évalué',
    fp_percentile: 'e percentile',
    fp_domainTypical: '✓ Typique',
    fp_domainBorderline: '⚠ Limite',
    fp_domainHighRisk: '✗ Risque élevé',
    fp_aiReportTitle: 'Rapport personnalisé par IA',
    fp_aiGenerating: 'DysTest AI génère votre rapport personnalisé…',
    fp_aiGenerated: 'Généré par DysTest AI · Pas un diagnostic clinique',
    fp_aiAnalysing: "Analyse des données d'évaluation…",
    fp_strengths: 'Points forts',
    fp_areasToSupport: 'Domaines à soutenir',
    fp_noDifficulties: 'Aucune difficulté significative détectée.',
    fp_eyeTracking: 'Suivi oculaire :',
    fp_recommendations: 'Recommandations',
    fp_nextStep: 'Prochaine étape :',
    pp_title: 'Politique de Confidentialité',
    pp_bannerTitle: 'Votre Vie Privée est Sacrée',
    pp_bannerDesc: "Nous croyons que vos données personnelles vous appartiennent, non à nous pour les vendre. Nous collectons uniquement ce qui est nécessaire pour un dépistage précis de la dyslexie, et nous le protégeons avec une sécurité de pointe. Vous avez toujours un contrôle total sur vos informations.",
    pp_contactTitle: 'Questions Sur Votre Confidentialité ?',
    pp_contactDesc: "Nous nous engageons à la transparence. Si vous avez des questions sur la façon dont nous traitons vos données, nous sommes là pour vous aider.",
    pp_privacyInquiries: 'Demandes de Confidentialité',
    pp_generalSupport: 'Support Général',
    pp_acknowledgment: "En utilisant le service DysTest, vous reconnaissez avoir lu et compris cette Politique de Confidentialité.",
    tos_title: "Conditions d'Utilisation",
    tos_missionTitle: 'Notre Mission',
    tos_missionDesc: "Comprendre son propre esprit ne devrait pas être un luxe — c'est un droit humain. Notre mission est de rendre le dépistage de la dyslexie accessible, abordable et précis pour chaque famille qui en a besoin.",
    tos_contactTitle: 'Questions Sur Ces Conditions ?',
    tos_contactDesc: "Nous sommes là pour vous aider. Si vous avez des questions sur nos Conditions d'Utilisation, n'hésitez pas à nous contacter.",
    tos_acknowledgment: "En utilisant le service DysTest, vous reconnaissez avoir lu, compris et accepté d'être lié par ces Conditions d'Utilisation.",
    shared_quickNav: 'Navigation Rapide',
    shared_backHome: "← Retour à l'Accueil",
    shared_effectiveDate: 'Date d\'entrée en vigueur : 30 octobre 2025',
    shared_lastUpdated: 'Dernière mise à jour : 30 octobre 2025',
    shared_footerTagline: 'Rendre les tests de dyslexie précis, accessibles et abordables.',
    shared_website: 'Site Web',
    shared_email: 'E-mail',
    blog_knowledgeBadge: 'Centre de connaissance DysTest',
    blog_title: 'Blog DysTest',
    blog_subtitle: "Expertises sur la dyslexie, les difficultés d'apprentissage et comment l'IA révolutionne la détection précoce et le soutien",
    blog_searchPlaceholder: "Rechercher des articles sur la dyslexie, les difficultés d'apprentissage, l'évaluation par IA...",
    blog_catAll: 'Tous',
    blog_catUnderstanding: 'Comprendre la dyslexie',
    blog_catEarlyDetection: 'Détection précoce',
    blog_catTechnology: 'Technologie',
    blog_catNews: 'Actualités',
    blog_featuredBadge: '⭐ En vedette',
    blog_featuredArticles: 'Articles en vedette',
    blog_allArticles: 'Tous les articles',
    blog_article: 'article',
    blog_articles: 'articles',
    blog_readMore: 'Lire la suite →',
    blog_found: 'Trouvé',
    blog_forQuery: 'pour',
    blog_noResults: 'Aucun article trouvé',
    blog_noResultsDesc: 'Essayez d\'ajuster votre recherche ou vos critères de filtre',
    blog_clearFilters: 'Effacer les filtres et afficher tous les articles',
    blog_newsletterTitle: 'Restez informé sur la recherche en dyslexie',
    blog_newsletterDesc: 'Recevez les dernières informations sur la recherche en dyslexie, la technologie IA et les stratégies d\'apprentissage dans votre boîte de réception.',
    blog_newsletterBtn: 'S\'abonner aux mises à jour',
    blog_newsletterPrivacy: 'Pas de spam. Désinscription à tout moment. Nous respectons votre vie privée.',
    blog_newsletterEmailPlaceholder: 'Entrez votre e-mail',
    blog_newsletterSending: 'Envoi…',
    blog_newsletterCheckInbox: 'Presque fini — consultez votre boîte de réception et cliquez sur le lien pour confirmer.',
    blog_newsletterError: 'Une erreur est survenue. Veuillez réessayer plus tard.',
    nws_working: 'Un instant…',
    nws_confirmedTitle: 'Vous êtes inscrit',
    nws_confirmedBody: 'Merci ! Vous recevrez les nouveaux articles de blog, les documents techniques et notre newsletter. Chaque e-mail contient un lien de désinscription.',
    nws_wasUnsubscribed: 'Cette adresse a été désinscrite. Inscrivez-vous à nouveau sur le blog pour recevoir les nouvelles.',
    nws_unsubTitle: 'Se désinscrire des nouvelles de DysTest ?',
    nws_unsubBody: 'Vous ne recevrez plus de nouveaux articles de blog, documents techniques ni newsletters.',
    nws_unsubBtn: 'Se désinscrire',
    nws_unsubDoneTitle: 'Vous êtes désinscrit',
    nws_unsubDoneBody: 'Vous ne recevrez plus de nouvelles. Vous avez changé d\'avis ? Vous pouvez vous réinscrire sur le blog.',
    nws_invalidTitle: 'Ce lien n\'est pas valide',
    nws_invalidBody: 'Le lien est peut-être ancien ou incomplet. Vous pouvez vous réinscrire sur le blog.',
    nws_toBlog: 'Aller au blog',
    blog_backToArticles: 'Retour aux articles',
    blog_loadingArticle: 'Chargement de l\'article...',
    blog_articleNotFound: 'Article non trouvé',
    blog_ctaTitle: 'Prêt à en savoir plus ?',
    blog_ctaDesc: 'Découvrez comment DysTest peut aider à identifier les difficultés d\'apprentissage et libérer le potentiel de chaque enfant avec notre évaluation par IA.',
    blog_tryDystest: 'Essayez l\'évaluation DysTest',
    blog_readMoreArticles: 'Lire d\'autres articles',
    faq_badge: 'Des questions ? Nous avons les réponses',
    faq_title: 'Questions fréquemment posées',
    faq_subtitle: 'Tout ce que vous devez savoir sur notre',
    faq_subtitleHighlight: 'Dépistage de la dyslexie par suivi oculaire',
    faq_searchPlaceholder: "Rechercher des questions... (ex : 'coût', 'confidentialité', 'durée')",
    faq_mostPopular: 'Questions les plus populaires',
    faq_noResults: 'Aucune question trouvée correspondant à votre recherche.',
    faq_clearFilters: 'Effacer les filtres',
    faq_stillHave: 'Vous avez encore des questions ?',
    faq_supportDesc: "Notre équipe d'assistance est là pour vous aider. Nous répondons généralement dans les 24 heures.",
    faq_contactSupport: "Contacter l'assistance",
    faq_startScreening: 'Commencer le dépistage',
    faq_catAll: 'Tous',
    faq_related: 'En rapport :',
    about_badge: 'Notre Histoire',
    about_title: 'À propos de DysTest',
    about_subtitle: 'Nous croyons que chaque enfant mérite d\'être compris — pas seulement testé.',
    about_backHome: '← Retour à l\'accueil',
    about_ctaTitle: 'Prêt à commencer ?',
    about_ctaDesc: 'Démarrez un dépistage bienveillant pour votre enfant aujourd\'hui et découvrez comment DysTest aide à révéler le potentiel de chaque apprenant.',
    about_startScreening: 'Commencer le dépistage',
    about_startAssessment: 'Commencer',
    about_navWhy: 'Pourquoi DysTest Existe',
    about_navMissionValues: 'Mission & Valeurs',
    about_navTechnology: 'Technologie',
    about_navTeam: 'Les Personnes Derrière DysTest',
    ran_audio_preLetter: 'Dénomination de lettres. Lisez chaque rangée de lettres à voix haute aussi vite que possible.',
    ran_audio_preDigit: 'Maintenant les chiffres. Lisez chaque rangée de chiffres à voix haute aussi vite que possible.',
    ran_audio_preColor: 'Maintenant les couleurs. Dites la couleur de chaque carré à voix haute aussi vite que possible.',
    ran_audio_preObject: 'Maintenant les objets. Nommez chaque image à voix haute aussi vite que possible.',
    ran_audio_runLetter: 'Lisez chaque lettre à voix haute aussi vite que possible.',
    ran_audio_runDigit: 'Lisez chaque chiffre à voix haute aussi vite que possible.',
    ran_audio_runColor: 'Dites la couleur de chaque carré à voix haute aussi vite que possible.',
    ran_audio_runObject: 'Nommez chaque image à voix haute aussi vite que possible.',
    ran_audio_practice: 'Entraînons-nous. Dites chaque lettre à voix haute.',
    ran_intro_t1_heading: 'Disons des lettres ! 🔤',
    ran_intro_t1_desc1: "Tu vas voir de grandes lettres sur l'écran.",
    ran_intro_t1_desc2: 'Dis chacune à voix haute aussi vite que tu peux !',
    ran_intro_heading: 'RAN',
    ran_intro_desc1: 'Vous verrez des rangées de lettres, chiffres, couleurs et objets. Lisez chaque rangée à voix haute aussi vite que possible — de gauche à droite.',
    ran_intro_desc2: "L'évaluateur appuiera sur Rangée suivante après chaque rangée. Nous ferons d'abord un court entraînement.",
    ran_intro_labLetters: 'Lettres',
    ran_intro_labDigits: 'Chiffres',
    ran_intro_labColors: 'Couleurs',
    ran_intro_labObjects: 'Objets',
    ran_practice_t1_heading: 'Tu peux dire ceux-ci ? 👀',
    ran_practice_heading: 'Entraînement',
    ran_practice_t1_desc: 'Dis chaque lettre à voix haute. Commence par la gauche !',
    ran_practice_desc: "Lisez cette rangée de lettres à voix haute, de gauche à droite. L'évaluateur tape sur Rangée suivante quand vous avez fini.",
    ran_practice_hint: 'Dites : "a · o · s · p · k" — puis tapez sur le bouton ci-dessous.',
    ran_btn_try: 'Essayons ! 🎉',
    ran_btn_practise: 'Entraînons-nous',
    ran_btn_skip: 'Passer',
    ran_btn_gotIt: 'Compris — commencer les lettres →',
    ran_btn_begin: 'Commencer — lire la rangée 1 →',
    ran_btn_nextRow: 'Rangée suivante',
    ran_btn_continue: 'Continuer',
    ran_preLetter_title: 'Dénomination de lettres  (RAN-L)',
    ran_preLetter_subtitle: '50 lettres · 5 rangées de 10. Lisez chaque rangée à voix haute aussi vite que possible.',
    ran_preLetter_detail: "L'évaluateur tapera sur Rangée suivante après chaque rangée.",
    ran_preLetter_btn: 'Afficher la grille →',
    ran_preDigit_title: 'Lettres terminées ! Maintenant les chiffres  (RAN-D)',
    ran_preDigit_subtitle: 'La même tâche avec des chiffres : 2 · 4 · 5 · 7 · 8',
    ran_preDigit_detail: '50 chiffres · 5 rangées de 10 · mêmes règles.',
    ran_preDigit_btn: 'Commencer les chiffres →',
    ran_preColor_title: 'Chiffres terminés ! Maintenant les couleurs  (RAN-C)',
    ran_preColor_subtitle: 'Dites la couleur de chaque carré à voix haute, aussi vite que possible.',
    ran_preColor_detail: '50 carrés colorés · 5 rangées de 10 · mêmes règles.',
    ran_preColor_btn: 'Commencer les couleurs →',
    ran_preObject_title: 'Couleurs terminées ! Maintenant les objets  (RAN-O)',
    ran_preObject_subtitle: 'Nommez chaque image à voix haute, aussi vite que possible.',
    ran_preObject_detail: '50 objets · 5 rangées de 10 · mêmes règles.',
    ran_preObject_btn: 'Commencer les objets →',
    ran_done_t1_heading: 'Travail incroyable ! 🌟',
    ran_done_heading: 'Toutes les tâches de dénomination terminées !',
    ran_done_t1_desc: 'Tu as dit toutes les lettres !',
    ran_done_desc: 'Voici les résultats :',
    ran_badge: 'Test de dénomination rapide',
    ran_intro_watchDemo: '👀 Regarde comment ça fonctionne',
    ran_intro_t1_lead: 'Regarde chaque lettre et dis-la à voix haute aussi vite que possible — de gauche à droite !',
    ran_intro_step1: 'Regarde la rangée',
    ran_intro_step2: 'Dis chaque élément à voix haute',
    ran_intro_step3: 'Va aussi vite que possible !',
    ran_intro_demoLabel: 'Dis chaque élément à voix haute, aussi vite que possible !',
    ran_btn_start: 'Démarrer 🚀',
    ran_btn_tapStart: 'Cliquez pour commencer la rangée 1',
    ran_btn_listening: 'Écoute…',
    ran_btn_repeat: 'Répéter l\'instruction',
    ran_processing: 'Traitement…',
    ran_transcribing: 'Transcription audio avec Whisper…',
    ran_transcribingDesc: 'Analyse de la précision vocale — cela prend quelques secondes',
    ran_stat_totalTime: 'Temps total',
    ran_stat_itemsPerSec: 'Éléments/s',
    ran_stat_avgItem: 'Moy. élément',
    ran_stat_mistakes: 'Erreurs',
    ran_paceHint: 'Surligné = rangée actuelle  ·  L\'évaluateur contrôle le rythme',
    ran_running_letter: '🔤 RAN-L — Lettres',
    ran_running_digit: '🔢 RAN-D — Chiffres',
    ran_running_color: '🎨 RAN-C — Couleurs',
    ran_running_object: '🦎 RAN-O — Objets',
    ran_header_letter: 'RAN-L',
    ran_header_digit: 'RAN-D',
    ran_header_color: 'RAN-C',
    ran_header_object: 'RAN-O',

    nav_home: 'Accueil',
    nav_about: 'À propos',
    nav_resources: 'Ressources',
    nav_startAssessment: 'Commencer l’évaluation',
    nav_langMenuTitle: 'Langue de l’évaluation',
    nav_langMenuHint: 'Les histoires et les consignes suivent cette langue',
    nav_techPapers: 'Articles Techniques',
    nav_blog: 'Blog',
    nav_guides: 'Guides',
    nav_faq: 'FAQ',

        wwt_badge: "Test d'écriture de mots",
    wwt_introTitle: 'Mémorisez et tapez le mot',
    wwt_introDesc: "Un mot apparaît pendant 5 secondes — puis il s'effface lettre par lettre et vous le tapez de mémoire",
    wwt_demoHint: 'Le mot disparaît — vous le tapez de mémoire',
    wwt_startWriting: 'Commencer à écrire !',
    wwt_rememberWord: 'Mémorise ce mot',
    wwt_watchCountdown: 'Regarde le compte à rebours — puis écris-le de mémoire',
    wwt_typeWord: 'Écris le mot que tu as vu',
    wwt_pressEnter: 'Tape-le et appuie sur Entrée ou Suivant',
    wwt_nextWord: 'Mot suivant',
    wwt_finish: 'Terminer',
    wwt_done: 'Bien joué !',
    wwt_correct: 'mots corrects',
    wwt_continue: 'Continuer',
    wwt_wordOf: 'Mot {current} sur {total}',
    form_badgeText: 'Étape 1/8 : Inscription',
    form_heading: "S'inscrire et commencer",
    form_privacyNote: "Vos données sont protégées par les réglementations RGPD et MDR. Aucune information personnellement identifiable n'est partagée avec des tiers.",

    // ── Microphone check panel (mic_*) ───────────────────────────────────
    mic_title: 'Vérification du microphone',
    mic_sub_checking: 'Vérification du microphone…',
    mic_sub_ready: 'Microphone prêt — appuyez sur Tester pour enregistrer',
    mic_sub_recording: 'Enregistrement… parlez maintenant',
    mic_sub_retry: 'Nous ne vous avons pas bien entendu — réessayez',
    mic_sub_passed: 'Le microphone fonctionne parfaitement !',
    mic_sub_denied: 'Accès au microphone refusé',
    mic_pleaseSpeak: "🗣️ Parlez maintenant, s'il vous plaît…",
    mic_retryBody: "Nous n'avons pas pu vous entendre clairement. Parlez un peu plus fort et réessayez.",
    mic_testBtn: 'Tester le microphone',
    mic_tryAgain: 'Réessayer',
    mic_continueBtn: 'Continuer',
    mic_skipDenied: 'Ignorer (pas de microphone)',
    mic_skip: 'Ignorer la vérification du microphone',
    ud_myDashboard: 'Mon tableau de bord',
    ud_myAssessmentReports: 'Mes rapports d\'évaluation',
    ud_noAssessmentsFound: 'Aucune évaluation complétée trouvée.',
    ud_assessmentsFoundSingular: '1 évaluation complétée trouvée.',
    ud_assessmentsFoundPlural: '{n} évaluations complétées trouvées.',
    ud_loadError: 'Impossible de charger vos évaluations. Vérifiez votre connexion et rechargez la page.',
    ud_serviceUnavailable: 'Le serveur est temporairement indisponible (503). Veuillez patienter et actualiser la page.',
    ud_progressOverTime: 'Progression dans le temps',
    ud_longitudinalSubtitle: '{n} évaluations · tendance du score z composite',
    ud_typical: 'Typique (z ≥ −0,5)',
    ud_borderline: 'Limite (z < −0,5)',
    ud_highRisk: 'Risque élevé (z < −1,0)',
    ud_veryHighRisk: 'Risque très élevé (z < −1,5)',
    ud_noAssessmentsFor: 'Aucune évaluation trouvée pour',
    ud_completeAssessment: 'Complétez une évaluation pour voir vos résultats ici.',
    ud_startAssessment: 'Commencer une évaluation',
    ud_assessmentReport: 'Rapport d\'évaluation',
    ud_completed: 'Complété',
    ud_accuracy: 'PRÉCISION',
    ud_blinks: 'CLIGNEMENTS',
    ud_questions: 'QUESTIONS',
    ud_rawData: 'Données brutes (JSON)',
    ud_tabEyeTracking: 'Suivi oculaire',
    ud_tabRan: 'Analyse RAN',
    ud_tabStory: 'Analyse des histoires',
    ud_gazePlaybackTitle: 'Lecture du suivi oculaire — 3 modes : Grille · Carte thermique · Chemin',
    ud_noGazeData: 'Aucune donnée de suivi oculaire disponible pour cette évaluation.',
    ud_gazeDataNote: 'Les données de suivi oculaire sont capturées pendant la session d\'évaluation en direct et stockées avec le rapport.',
    ud_ranTitle: 'RAN — Résultats de la dénomination automatisée rapide',
    ud_totalTime: 'Temps total',
    ud_rawSpeed: 'Vitesse brute',
    ud_correctedSpeed: 'Vitesse corrigée',
    ud_errors: 'Erreurs',
    ud_rowTimings: 'Temps par ligne',
    ud_transcriptComparison: 'Comparaison de transcription',
    ud_row: 'Ligne',
    ud_audioNote: 'La lecture audio est disponible dans le rapport ZIP complet · Télécharger le rapport complet (ZIP) ci-dessus',
    ud_storyTitle: 'Analyse de lecture d\'histoire',
    ud_story1Label: 'Histoire 1 — Phase de lecture',
    ud_story2Label: 'Histoire 2 — Phase de lecture',
    ud_readingTime: 'Temps de lecture',
    ud_fixations: 'Fixations',
    ud_regressions: 'Régressions',
    ud_avgFixation: 'Fix. moy.',
    ud_saccades: 'Saccades',
    ud_blinkRate: 'Taux de clignement',
    ud_gazeStoryTitle: 'Suivi oculaire — Pages d\'histoire',
    ud_noStoryGaze: 'Données de suivi oculaire des histoires non disponibles pour cette évaluation.',
    ud_footer: 'Vos données sont stockées de manière sécurisée uniquement sur cet appareil.',
    ud_changePassword: 'Changer le mot de passe',
    ud_changePasswordDesc: 'Définissez un nouveau mot de passe pour votre compte. Vous l\'utiliserez la prochaine fois que vous vous connecterez.',
    ud_passwordUpdated: 'Mot de passe mis à jour avec succès',
    ud_newPasswordPlaceholder: 'Nouveau mot de passe (min. 4 caractères)',
    ud_saving: 'Enregistrement…',
    ud_saveNewPassword: 'Enregistrer le nouveau mot de passe',
    ud_passwordTooShort: 'Le mot de passe doit comporter au moins 4 caractères.',
    ud_passwordUpdateFailed: 'Impossible de mettre à jour votre mot de passe. Veuillez réessayer.',
    ud_accuracySuffix: 'précision',
    acp_tabCamera: 'Caméra',
    acp_tabKeyboard: 'Clavier',
    acp_tabMicrophone: 'Microphone',
    acp_checkingCameraQuality: 'Vérification de la qualité de la caméra — cela prend quelques secondes',
    acp_allChecksPassed: 'Toutes les vérifications réussies !',
    acp_allSystemsReady: 'Caméra, clavier et microphone sont prêts.',
    mini_step: 'Étape',
    scp_setupComplete: '🎉 Configuration terminée !',
    scp_allSetSubtitle: 'Vous êtes prêt pour l\'évaluation de la dyslexie',
    scp_setupQualityScore: 'Score de qualité de configuration',
    scp_excellentSetup: 'Excellente qualité de configuration pour une évaluation précise',
    scp_completedSteps: '✅ Étapes terminées',
    scp_cameraReadiness: 'Préparation de la caméra',
    scp_cameraStabilityPassed: 'Vérification de stabilité de 10 secondes réussie',
    scp_keyboardCapture: 'Capture du clavier',
    scp_keystrokeData: 'Données de frappe cliniques capturées',
    scp_eyeCalibration: 'Calibration oculaire',
    scp_calibrationCompleted: 'Calibration terminée ({pct}% de précision)',
    scp_whatsNext: 'Et ensuite ?',
    scp_whatsNextBody: 'Vous commencerez l\'évaluation de lecture où nous analyserons vos mouvements oculaires, vos expressions faciales et vos schémas de lecture pour un dépistage complet de la dyslexie.',
    scp_startAssessment: 'Démarrer l\'évaluation de la dyslexie',
    scp_startingAssessment: 'Démarrage de l\'évaluation...',
    scp_estimatedTime: 'Durée estimée : 10-15 minutes',

    // Grille de rapports UserDashboard
    ud_view: 'Voir',
    ud_report_userInfo: 'Informations utilisateur',
    ud_report_envSetup: 'Configuration environnement',
    ud_report_wordIcon: 'Association mot-icône',
    ud_report_ran: 'Analyse RAN',
    ud_report_story: 'Analyse d\'histoire',
    ud_report_wordWriting: 'Écriture de mots',
    ud_report_feedback: 'Retour',
    ud_report_summary: 'Résumé',
    ul_platform: 'Plateforme d’évaluation de la dyslexie',
    ul_invalidCredentials: 'E-mail ou mot de passe invalide. Vérifiez les identifiants affichés à la fin de votre évaluation.',
    ul_loginFailed: 'Connexion échouée. Veuillez réessayer.',
    ul_resetFailed: 'Une erreur est survenue. Veuillez réessayer.',
    ul_backToSignIn: 'Retour à la connexion',
    ul_checkEmail: 'Vérifiez votre e-mail',
    ul_smtpDevNotice: 'SMTP non configuré (dev). Mot de passe temporaire :',
    ul_resetSent: 'Si {email} est enregistré, un nouveau mot de passe est en route.',
    ul_signIn: 'Se connecter',
    ul_resetPassword: 'Réinitialiser le mot de passe',
    ul_resetPasswordDesc: 'Saisissez votre e-mail et nous vous enverrons un nouveau mot de passe.',
    ul_emailAddress: 'Adresse e-mail',
    ul_emailPlaceholder: 'vous@email.com',
    ul_sending: 'Envoi…',
    ul_sendNewPassword: 'Envoyer un nouveau mot de passe',
    ul_welcomeBack: 'Bon retour',
    ul_signInSubtitle: 'Connectez-vous pour voir vos résultats d’évaluation',
    ul_password: 'Mot de passe',
    ul_passwordPlaceholder: 'Votre mot de passe',
    ul_hidePassword: 'Masquer le mot de passe',
    ul_showPassword: 'Afficher le mot de passe',
    ul_forgotPassword: 'Mot de passe oublié ?',
    ul_signingIn: 'Connexion…',
    ul_signInDashboard: 'Accéder à votre tableau de bord',
    ul_firstTime: 'Première visite ? Votre compte a été créé automatiquement après votre évaluation. Vérifiez votre e-mail pour les identifiants.',
    ul_footer: 'Conforme RGPD & MDR · Aucune vidéo stockée',

    mg_title: 'Un peu de patience, pour la science !',
    mg_body: 'DysTest analyse les mouvements de tes yeux (au pixel près !), ta vitesse de frappe et ta voix à la milliseconde près.\n\nUne technologie super intelligente, mais elle a un point faible : elle ne fonctionne pas quand ton écran bouge dans ta main. Ouvre donc un ordinateur portable ou de bureau pour un résultat fiable !',
    mg_howTo: 'Pour commencer',
    mg_step1: 'Ouvrez dystest.com sur un ordinateur portable ou de bureau',
    mg_step2: 'Vérifiez que votre webcam et votre clavier sont connectés',
    mg_step3: 'Utilisez Chrome ou Firefox pour de meilleurs résultats',
    mg_returnHome: "Retour à la page d'accueil",
    mg_shareLink: 'M\'envoyer le lien',
    mg_copyLink: 'Copier le lien',
    mg_linkCopied: 'Lien copié',
    mg_alreadyDone: 'Déjà fait un test ?',
    mg_loginLink: 'Se connecter pour voir le rapport',
    mg_emailLabel: 'Votre adresse e-mail',
    mg_emailPlaceholder: 'nom@exemple.fr',
    mg_emailSend: 'Envoyer',
    mg_emailSent: 'Envoyé ! Ouvrez l\'e-mail sur votre ordinateur pour commencer le test.',
    mg_emailError: 'L\'e-mail n\'a pas pu être envoyé. Vérifiez l\'adresse et réessayez.',
};

export default fr;
